import { ChapterLabel, Container, FadeUp, MaskedLine } from "./ui";

const STEPS = [
  {
    num: "01",
    title: "SOURCER",
    text: "Nous identifions les prestataires capables de répondre précisément à votre demande.",
  },
  {
    num: "02",
    title: "NÉGOCIER",
    text: "Nous recherchons les meilleures conditions disponibles selon votre besoin, vos contraintes et votre niveau d'exigence.",
  },
  {
    num: "03",
    title: "COORDONNER",
    text: "Nous organisons l'ensemble de la prestation jusqu'à sa réalisation.",
  },
];

const Concept = () => (
  <section id="approche" className="bg-ink py-28 md:py-40" data-testid="concept-section">
    <Container>
      <ChapterLabel num="01" label="The InVogue Approach" />

      <h2 className="mt-10 font-serif font-medium leading-[0.95] text-ivory text-[clamp(40px,5.4vw,84px)]">
        <MaskedLine delay={0.1}>VOUS DEMANDEZ.</MaskedLine>
        <MaskedLine delay={0.2} className="text-champagne">
          NOUS NOUS OCCUPONS DU RESTE.
        </MaskedLine>
      </h2>

      <div className="mt-16 grid gap-16 md:mt-24 md:grid-cols-2 md:gap-24">
        <FadeUp delay={0.1}>
          <div className="space-y-5 font-sans text-[15px] font-light leading-[1.8] text-neutral-400 md:text-base">
            <p className="text-ivory">Une simple demande peut vite devenir chronophage.</p>
            <p>
              Trouver le bon prestataire. Vérifier les disponibilités. Comparer les
              options. Négocier. Planifier. Relancer. Coordonner.
            </p>
            <p className="pt-3 text-ivory">INVOGUE s'occupe de la recherche pour vous.</p>
            <p>
              Vous nous dites ce dont vous avez besoin. Nous identifions les solutions
              pertinentes, activons notre réseau, coordonnons l'exécution et restons
              votre interlocuteur unique jusqu'à la résolution de votre demande.
            </p>
          </div>
        </FadeUp>

        <div className="space-y-0">
          {STEPS.map((s, i) => (
            <FadeUp key={s.num} delay={0.1 + i * 0.12}>
              <div
                className="flex gap-8 border-t border-line py-9 last:border-b"
                data-testid={`step-${s.num}`}
              >
                <span className="font-serif text-[56px] font-medium leading-none text-champagne/60 md:text-[72px]">
                  {s.num}
                </span>
                <div className="pt-2">
                  <h3 className="font-display text-[12px] font-semibold tracking-[0.2em] text-ivory">
                    {s.title}
                  </h3>
                  <p className="mt-3 max-w-[380px] font-sans text-sm font-light leading-[1.7] text-neutral-400">
                    {s.text}
                  </p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default Concept;
